import { QuoteDTO, QuoteItemDTO } from '@setvi/shared/services/react-query';
import { useQuoteMutation } from './create-quote-mutation';

interface ReorderItemsVariables {
  reorderedItems: QuoteItemDTO[];
}

/**
 * Apply reordered items to quote optimistically
 * Replaces the entire items array with the new order
 */
const reorderItemsOptimistically = (
  quote: QuoteDTO | undefined,
  { reorderedItems }: ReorderItemsVariables
): QuoteDTO | undefined => {
  if (!quote) return quote;

  return {
    ...quote,
    items: reorderedItems
  };
};

/**
 * Reorder items in quote with optimistic updates
 * Items are saved in the new order immediately in UI before API confirmation
 */
export const useReorderItems = (quoteId: string) =>
  useQuoteMutation<ReorderItemsVariables>({
    quoteId,
    optimisticUpdate: reorderItemsOptimistically
  });
